import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import DeleteButton from 'modules/budget/components/category/category-table/delete-button';
import EditButton from 'modules/budget/components/category/category-table/edit-button';
import HideButton from 'modules/budget/components/category/category-table/hide-button';

@withNamespaces()
@observer
class Subcategory extends Component {
    render() {
        const { t, category, hidden } = this.props;
        const { id, name, custom } = category;
        const parentName = category.parent.name;

        return (
            <tr id={`subcategory-${id}`}>
                <td style={{borderLeft: '10px solid gray'}} className="p-l-50">
                    {t(parentName)}: {t(name)}
                </td>
                <td className="text-right">
                    <div className="btn-group">
                        <HideButton category={category} hidden={hidden} />
                        {custom && !hidden && (
                            <Fragment>
                                <EditButton category={category} />
                                <DeleteButton category={category} />
                            </Fragment>
                        )}
                    </div>
                </td>
            </tr>
        )
    }
}

Subcategory.propTypes = {
    /** A Category reference from the store */
    category: PropTypes.any.isRequired,

    /** Whether this component is displaying hidden categories */
    hidden: PropTypes.bool,
};

export default Subcategory;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/subcategory.js